import type { ChatTranscriptItem } from '../../api/types'

/** A passage kb_search returned (tool metadata), as the chat cites it: [n]. */
export interface KbPassageRef { n: number; ref: string; title: string; headingPath: string; page: number | null; collection: string }

export const CITE_PREFIX = '#kb-cite-'

/** For each assistant message, the kb_search passages of its turn (since the last user message), by number. */
export function citationsByMessage(items: ChatTranscriptItem[]): Map<string, Map<number, KbPassageRef>> {
  const out = new Map<string, Map<number, KbPassageRef>>()
  let turn = new Map<number, KbPassageRef>()
  for (const item of items) {
    if (item.kind === 'tool') {
      const list = item.tool.tool === 'kb_search' ? item.tool.metadata?.kbPassages : undefined
      if (Array.isArray(list)) for (const p of list as KbPassageRef[]) turn.set(p.n, p)
      continue
    }
    if (item.message.role === 'user') turn = new Map()
    else if (item.message.role === 'assistant' && turn.size) out.set(item.message.id, new Map(turn))
  }
  return out
}

/** `[n]` with a known passage → a Markdown link the renderer turns into a chip; code, links and definitions untouched. */
export function linkCitations(text: string, known: Map<number, unknown>): string {
  if (!known.size) return text
  return text.split(/(```[\s\S]*?```|`[^`\n]*`)/g)
    .map((part, i) => (i % 2 ? part : part.replace(/\[(\d{1,3})\](?![(:])/g, (m, d: string) => (known.has(Number(d)) ? `[[${d}]](${CITE_PREFIX}${d})` : m))))
    .join('')
}
